<template>
	<!-- 重庆时时彩 -->
	<div class="allgame-mainbox lottery" :class="{ lowLotteryClass }">
		<div class="box_center">
			<!--我的收藏列表-->
			<favoriteList class="fixed-left" />
			<!-- 中奖信息 -->
			<gamePanelTitle
				:logoImgUrl="logoImgUrl"
				:time="countDown"
				:LastLssue="LastLssue"
				:GameIds="GameIds"
				:NowLssue="NowLssue"
				:GameName="playGameName"
				@upTimeData="upTimeData"
			>
				<open-number :data-array="LastNum" />
			</gamePanelTitle>
			<!-- 玩法内容 -->
			<div class="gametype_center">
				<!-- 主要内容 -->
				<div class="Timhonor_content_box">
					<!-- 中间内容板块-->
					<div class="content_info">
						<!-- 左边选号内容 -->
						<div class="content_box_left">
							<!-- 最顶部导航栏 -->
							<!-- 时时彩 -->
							<div class="content_nav" v-if="GameIndex === '1'">
								<template v-if="GameIds === 2 || GameIds === 44">
									<ul class="content_nav_top box_h">
										<li><a :class="NavSwich === 0 ? 'select_a' : ''" :data-id="0" @click="topNavSwitch">前三</a></li>
										<li><a :class="NavSwich === 1 ? 'select_a' : ''" :data-id="1" @click="topNavSwitch">中三</a></li>
										<li><a :class="NavSwich === 2 ? 'select_a' : ''" :data-id="2" @click="topNavSwitch">后三</a></li>
										<li><a :class="NavSwich === 3 ? 'select_a' : ''" :data-id="3" @click="topNavSwitch">二星</a></li>
										<li><a :class="NavSwich === 4 ? 'select_a' : ''" :data-id="4" @click="topNavSwitch">定位胆</a></li>
										<li><a :class="NavSwich === 5 ? 'select_a' : ''" :data-id="5" @click="topNavSwitch">不定位</a></li>
										<li><a :class="NavSwich === 6 ? 'select_a' : ''" :data-id="6" @click="topNavSwitch">龙虎</a></li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 0">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 1">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 2">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 3">
										<li class="second_navitembox box_h" @click="hisStyle(12)">
											<label>前二</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 3)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h" @click="hisStyle(13)">
											<label>后二</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(3)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 4">
										<li class="second_navitembox box_h">
											<label>定位胆</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary" v-if="NavSwich === 5">
										<li class="second_navitembox box_h">
											<label>三星</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>四星</label>
											<div class="box_flex second_item_mainbox box_h">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="item in navList.slice(4, 6)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<ul class="content_nav_secondary Dragon_Tiger" v-if="NavSwich === 6">
										<li class="second_navitembox box_h">
											<label>龙虎和</label>
											<div class="box_flex second_item_mainbox cf second_item_mainbox_ts">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
								</template>
								<template v-else>
									<ul class="content_nav_top box_h">
										<li><a :class="NavSwich === 0 ? 'select_a' : ''" :data-id="0" @click="topNavSwitch">五星</a></li>
										<li><a :class="NavSwich === 1 ? 'select_a' : ''" :data-id="1" @click="topNavSwitch">四星</a></li>
										<li><a :class="NavSwich === 2 ? 'select_a' : ''" :data-id="2" @click="topNavSwitch">前三</a></li>
										<li><a :class="NavSwich === 3 ? 'select_a' : ''" :data-id="3" @click="topNavSwitch">中三</a></li>
										<li><a :class="NavSwich === 4 ? 'select_a' : ''" :data-id="4" @click="topNavSwitch">后三</a></li>
										<li><a :class="NavSwich === 5 ? 'select_a' : ''" :data-id="5" @click="topNavSwitch">二星</a></li>
										<li><a :class="NavSwich === 6 ? 'select_a' : ''" :data-id="6" @click="topNavSwitch">定位胆</a></li>
										<li><a :class="NavSwich === 7 ? 'select_a' : ''" :data-id="7" @click="topNavSwitch">不定位</a></li>
										<li><a :class="NavSwich === 8 ? 'select_a' : ''" :data-id="8" @click="topNavSwitch">龙虎</a></li>
										<li><a :class="NavSwich === 9 ? 'select_a' : ''" :data-id="9" @click="topNavSwitch">任四</a></li>
										<li><a :class="NavSwich === 10 ? 'select_a' : ''" :data-id="10" @click="topNavSwitch">任三</a></li>
										<li><a :class="NavSwich === 11 ? 'select_a' : ''" :data-id="11" @click="topNavSwitch">任二</a></li>
										<li class="playing-mode">
											<router-link
												:to="{ name: 'gamePanel', query: { id: $route.query.id, index: $route.query.index } }"
												class="change_bth"
											>
												<span class="mode-official select">官方玩法</span>
												<span class="mode-classics">经典玩法</span>
											</router-link>
										</li>
									</ul>
									<!-- 次级导航 -->
									<!-- 五星 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 0">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 2)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(2, 8)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>趣味</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(8)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 四星 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 1">
										<li class="second_navitembox box_h" @click="hisStyle(14)">
											<label>前四</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 6)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h" @click="hisStyle(15)">
											<label>后四</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(6)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 前三 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 2">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 中三 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 3">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 后三 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 4">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>组选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 二星 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 5">
										<li class="second_navitembox box_h" @click="hisStyle(12)">
											<label>前二</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 3)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h" @click="hisStyle(13)">
											<label>后二</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(3)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 定位胆 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 6">
										<li class="second_navitembox box_h">
											<label>定位胆</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 不定位 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 7">
										<li class="second_navitembox box_h">
											<label>三星</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 4)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>四星</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(4, 6)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>五星</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(6, 8)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 龙虎斗 -->
									<ul class="content_nav_secondary Dragon_Tiger" v-if="NavSwich === 8">
										<li class="second_navitembox box_h">
											<label>龙虎和</label>
											<div class="box_flex second_item_mainbox cf second_item_mainbox_ts">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.select_two_a"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 任四 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 9">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 任三 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 10">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(0, 2)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
										<li class="second_navitembox box_h">
											<label>复选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList.slice(2)"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
									<!-- 任二 -->
									<ul class="content_nav_secondary" v-if="NavSwich === 11">
										<li class="second_navitembox box_h">
											<label>直选</label>
											<div class="box_flex second_item_mainbox cf">
												<div
													:class="[navsw === item.LpId ? 'select_two_a' : '']"
													v-for="(item, index) in navList"
													:key="item.LpId"
													:data-id="item.LpId"
													@click="smallSwitch"
													:data-name="item.Name"
												>
													{{ item.Alias }}
												</div>
											</div>
										</li>
									</ul>
								</template>
							</div>
							<!-- 11选5 -->
							<div class="content_nav" v-if="GameIndex === '3'">
								<ul class="content_nav_top box_h">
									<li><a :class="NavSwich === 0 ? 'select_a' : ''" :data-id="0" @click="topNavSwitch">三码</a></li>
									<li><a :class="NavSwich === 1 ? 'select_a' : ''" :data-id="1" @click="topNavSwitch">二码</a></li>
									<li><a :class="NavSwich === 2 ? 'select_a' : ''" :data-id="2" @click="topNavSwitch">不定位胆</a></li>
									<li><a :class="NavSwich === 3 ? 'select_a' : ''" :data-id="3" @click="topNavSwitch">定位胆</a></li>
									<li><a :class="NavSwich === 4 ? 'select_a' : ''" :data-id="4" @click="topNavSwitch">任选复式</a></li>
									<li><a :class="NavSwich === 5 ? 'select_a' : ''" :data-id="5" @click="topNavSwitch">任选单式</a></li>
								</ul>
								<!-- 前三 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 0">
									<li class="second_navitembox box_h">
										<label>前三直选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(0, 2)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
									<li class="second_navitembox box_h">
										<label>前三组选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(2, 4)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 前二 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 1">
									<li class="second_navitembox box_h">
										<label>前二直选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(0, 2)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
									<li class="second_navitembox box_h">
										<label>前二组选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(2, 4)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 不定位胆 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 2">
									<li class="second_navitembox box_h">
										<label>前三不定位</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 定位胆 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 3">
									<li class="second_navitembox box_h">
										<label>前三定位胆</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 任选复式 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 4">
									<li class="second_navitembox box_h">
										<label>任选复式</label>
										<div class="box_flex second_item_mainbox cf second_item_mainbox_ts">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 任选单式-->
								<ul class="content_nav_secondary" v-if="NavSwich === 5">
									<li class="second_navitembox box_h">
										<label>任选单式</label>
										<div class="box_flex second_item_mainbox cf second_item_mainbox_ts">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
							</div>
							<!-- 低频彩 -->
							<div class="content_nav" v-if="GameIndex === '6'">
								<ul class="content_nav_top box_h">
									<li><a :class="NavSwich === 0 ? 'select_a' : ''" :data-id="0" @click="topNavSwitch">三星</a></li>
									<li><a :class="NavSwich === 1 ? 'select_a' : ''" :data-id="1" @click="topNavSwitch">二星</a></li>
									<li><a :class="NavSwich === 2 ? 'select_a' : ''" :data-id="2" @click="topNavSwitch">定位胆</a></li>
									<li><a :class="NavSwich === 3 ? 'select_a' : ''" :data-id="3" @click="topNavSwitch">不定位胆</a></li>
								</ul>
								<!-- 三星 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 0">
									<li class="second_navitembox box_h">
										<label>直选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(0, 3)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
									<li class="second_navitembox box_h">
										<label>组选</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(3)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 二星 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 1">
									<li class="second_navitembox box_h">
										<label>前二</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(0, 3)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
									<li class="second_navitembox box_h">
										<label>后二</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList.slice(3)"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!--定位胆 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 2">
									<li class="second_navitembox box_h">
										<label>定位胆</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
								<!-- 不定位胆 -->
								<ul class="content_nav_secondary" v-if="NavSwich === 3">
									<li class="second_navitembox box_h">
										<label>不定位</label>
										<div class="box_flex second_item_mainbox cf">
											<div
												:class="[navsw === item.LpId ? 'select_two_a' : '']"
												v-for="(item, index) in navList"
												:key="item.LpId"
												:data-id="item.LpId"
												@click="smallSwitch"
												:data-name="item.Name"
											>
												{{ item.Alias }}
											</div>
										</div>
									</li>
								</ul>
							</div>
							<!-- 示例内容 -->
							<div class="demo_case">
								<div class="demo_left">
									{{ exampleObj[navsw].showTest || "" }}
									<div>
										<span>选号示例</span>
										<div>
											<p v-for="(item, index) in exampleObj[navsw].arr" :key="index">
												投注：{{ item.title || "" }} <br />
												开奖：{{ item.content || "" }}
											</p>
										</div>
									</div>
								</div>
								<div class="bonus_select">
									<span>奖金调节：</span>
									<el-select v-model="bonus" @change="adjustMent">
										<el-option v-for="(item, index) in userSelect" :key="index" :value="index" :label="item + '%'">
										</el-option>
									</el-select>
								</div>
							</div>
							<!--这里保留的原按照分组排列的信息,勿删!  下边是按照内容合并的列表-->
							<!--2 1 3 4 5 6 7 8 9 10 11 12 14 13 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69-->
							<!-- 龙虎斗 -->
							<!--70 71 72 73 74 75 77 78 79 80-->
							<!-- 11选5 -->
							<!-- 三码 -->
							<!--94 95 96 97-->
							<!-- 二码 -->
							<!--98 99 100 101-->
							<!-- 不定位胆 -->
							<!--102-->
							<!-- 定位胆 -->
							<!--103-->
							<!-- 任选复式 -->
							<!--104 106 107 109 111 113 115 117-->
							<!-- 任选单式 -->
							<!--105 108 110 112 114 116 118 182-->
							<!-- 福彩3D -->
							<!--168 169 170 171 172 173 174 175 176 177 178 179 180 181-->
							<!-- 选号内容 -->
							<template>
								<template
									v-if="
										[
											1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19, 21, 22, 23, 24, 25, 28, 29, 30, 32,
											35, 36, 37, 39, 42, 43, 44, 46, 48, 49, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 63, 68, 94,
											96, 98, 100, 102, 103, 104, 106, 107, 109, 111, 113, 115, 117, 168, 171, 172, 174, 176, 177, 179,
											180, 181,
										].includes(navsw)
									"
								>
									<gameCom
										class="select_num_div"
										ref="drag"
										@setdata="setGdata"
										:gameary="gameAry"
										:gameid="navsw"
										@setbet="setBetNum"
										v-if="GameState"
									/>
								</template>
								<template
									v-if="
										[
											2, 14, 20, 26, 31, 33, 38, 40, 45, 47, 50, 105, 108, 110, 112, 114, 116, 118, 182, 169, 173, 175,
											178,
										].includes(navsw)
									"
								>
									<optionvalue ref="drag" :gameid="navsw" @getdata="OptionGdata" />
								</template>
								<template v-if="[27, 34, 41, 170].includes(navsw)">
									<gameCount @setdata="setGdata" @setbet="setBetNum" ref="drag" v-if="GameState" />
								</template>
								<template v-if="[70, 71, 72, 73, 74, 75, 77, 78, 79, 80].includes(navsw)">
									<dragon :gameary="DorSomeAry" @setdata="setGdata" ref="drag" @setbet="setBetNum" :gameid="navsw" />
								</template>
								<template v-if="[62, 64, 67, 69].includes(navsw)">
									<optionvalue ref="drag" :gameid="navsw" @getdata="OptionGdata" @getdis="getDisData" />
								</template>
								<template v-if="[95, 97, 99, 101].includes(navsw)">
									<optionvalue ref="drag" :gameid="navsw" @getdata="OptionGdata" />
								</template>
								<template v-if="[65, 66].includes(navsw)">
									<gameCom
										class="select_num_div"
										ref="drag"
										@setdata="setGdata"
										:gameary="gameAry"
										:gameid="navsw"
										@setbet="setBetNum"
										@getdis="getDisData"
									/>
								</template>
							</template>
							<!-- 用户投注 -->
							<userpay
								ref="userPay"
								:mult="gameMultiplying"
								@bonus="Bonusadjust"
								:betnum="BetNum"
								:betmoney="BetMoney"
								@typeset="TypeSet"
								@gamemultiply="selectGameMultiply"
								:userselect="userSelect"
								@openmess="openMessAge"
								:mounttype="mountType"
								@dirbet="DisAjax"
								:balance="userBalace"
								@allin="AllIN"
							/>
						</div>
						<div class="content_box_right">
							<history :style-id="styleNum" :historyData="allLotterydata" />
						</div>
					</div>
					<div class="content_info content_info_record">
						<betting
							:time="countDown"
							@settrack="setTrack"
							:betary="betAry"
							:gameindex="GameIndex"
							@addnum="addNum"
							@emptynum="EmptyNum"
							@deletenum="deleteNum"
							@direct="aryDisAjax"
							:ids="navsw"
						/>
					</div>

					<!-- 表格 -->
					<tablelist :tablist="tableList" @setinfo="infoData" :tracklist="trackList" :indexs="GameIndex" />
					<!-- 倒计时结束后显示 -->
					<openResult v-if="openFrame" :redata="openDataRe" @hidere="hideOpenRe" />
					<!-- 提示框 -->
					<div class="game_message_box">
						<el-button :plain="true" @click="openMessAge" />
					</div>
					<!-- 未选择投注号码提示弹框 -->
					<betElast v-if="betMinA" @bethide="betMinAHide" />
					<!-- 追号详情 -->
					<zhDetali :zhdata="zhList" ref="dragZhDetali" @list="ListAjax" @getinfo="getUserInfo" />
					<!-- 投注成功 -->
					<betSuccess v-if="betSuccess" @bethide="hideBetSuc" />
					<!-- 详情弹框 -->
					<detali :getinfo="infoList" ref="dragDetali" @list="ListAjax" @getinfo="getUserInfo" />
					<!-- 追号投注弹框 -->
					<trackNum
						v-if="trackState"
						@hidetrack="hideTrack"
						:ary="betAry"
						@clearbet="clearBetAry"
						@list="ListAjax(true)"
						@getinfo="getUserInfo"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
//系统设置
import { SysKey } from "../../util/sysconfig";
// 倒计时结束后显示
import openResult from "../Elasticframe/Number_change";
// 追号投注
import trackNum from "../Elasticframe/Track_num";
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
// 投注记录组件
import betting from "../Subcomponents/Betting";
// 表格组件
import tablelist from "../Subcomponents/Tablelist";
// 用户投注组件
import userpay from "../Subcomponents/user_pay";
// 选号组件
import gameCom from "../Subcomponents/game_content";
// 和值
import gameCount from "../Subcomponents/game_Count";
// 用户自选号
import optionvalue from "../Subcomponents/Optionalvalue";
// 龙虎斗
import dragon from "../Subcomponents/Dragon_Tiger";
// 悬浮组件
import flextab from "../Subcomponents/flex_tab";
// 投注提示弹框
import betElast from "../Elasticframe/Betting_minone";
// 投注成功
import betSuccess from "../Elasticframe/Betting_success";
// 详情弹框
import detali from "../Elasticframe/infodetails";
// 秒数转化
import { SecondToHHSSMM } from "../../static/js/changeTime.js";
// 追号详情
import zhDetali from "../Elasticframe/zhdetails";
//开奖历史
import history from "../common/history";
//倒计时组件
import countDown from "../common/countDown";
//开奖号码
import openNumber from "../common/openNumber";
//提示信息
import sscJson from "../../json/ssc";
//收藏按钮
import favorite from "../common/favorite";
//左侧我的收藏卡片
import favoriteList from "../common/favoriteList";
import gamePanelTitle from "@/components/common/gamePanelTitle.vue";

var selectNavSwich = 0;
export default {
	// 刷新页面
	inject: ["reload"],
	data() {
		var gameId = parseInt(this.$route.query.id);
		if (gameId === 2 || gameId === 44) {
			selectNavSwich = 2;
		} else if (gameId === 27 || gameId === 28 || gameId === 29) {
			//福彩3D 排列三 上海时时乐
			selectNavSwich = 0;
		} else {
			selectNavSwich = 4;
		}
		return {
			timeNum: 0, //请求次数
			GameState: true, //组件状态
			openDataRe: {}, //开奖弹框数据
			openFrame: false, //倒计时结束弹框
			trackState: false, //追号投注页面
			userBalace: 0, //用户余额
			imgUrl: SysKey("ImgServerUrl").SysValue, //图片地址
			logoImgUrl: "", //彩票图标
			tableList: [], //传入表单子组件
			trackList: [], //出入表单子组件
			betSuccess: false, // 是否投注成功
			betMinA: false, //弹框是否显示
			choicenum: true, //五期一期切换显示
			NavSwich: selectNavSwich, //导航栏选中
			GameIds: parseInt(this.$route.query.id), //游戏ID
			GameIndex: this.$route.query.index.toString(), //游戏种类
			NowLssue: "", //当前期号
			dirNowLssue: "", //当前期号格式
			LastLssue: "", //近一期
			openTime: "", //开奖期数
			LastNum: {}, //近一期开奖号码
			animationState: true, //动画状态
			openGifClass: "icon", //开奖动画样式 默认是正常没有动画
			NowTime: 0, //投注倒计时
			countDown: {}, //投注倒计时
			navAllList: [], //返回所有玩法数组
			navList: [], //导航栏渲染内容
			allLotterydata: [], //全部开奖数据
			navsw: 25, //次级导航
			selectGName: "", //龙虎和选中的内容
			gameName: "", //玩法名称
			gameMultiplying: 1, //游戏倍率
			mountType: [], //模式
			mountTypeName: "2元", //模式名称
			mountTypeId: 1, //模式ID
			mountNum: 2, //初始金额
			Bonusrate: "",
			gameOdds: "", //玩法赔率
			gamePoint: "", //游戏返点
			CurrentPoint: 0, //当前返点
			BetNum: 0, //投注数量
			BetMoney: 0, //投注金额
			betary: [], //传入投注卡组件的内容
			betDis: [], // 投注位数
			styleNum: 4, //历史记录样式//0五星1四星2前三3中三4后三5二星0定位胆0不定位0任四任三任二
			DorSomeAry: [
				{ name: "龙", odds: "", state: "false", selectNav: "loong_icon", unselectNav: "unlong_icon" },
				{ name: "虎", odds: "", state: "false", selectNav: "tiger_icon", unselectNav: "untiger_icon" },
				{ name: "和", odds: "", state: "false", selectNav: "and_icon", unselectNav: "unand_icon" },
			], //传入龙虎斗组件内容
			// 传入子组件玩法赔率数组
			userSelect: ["1920.000-0.00%", "1900.000-1.00%"],
			// 传入玩法子组件的数据
			gameAry: [
				{ ids: 1, digit: "万位", num: this.TemplateNum1_9_0false() },
				{ ids: 2, digit: "千位", num: this.TemplateNum1_9_0false() },
				{ ids: 3, digit: "百位", num: this.TemplateNum1_9_0false() },
				{ ids: 4, digit: "十位", num: this.TemplateNum1_9_0false() },
				{ ids: 5, digit: "个位", num: this.TemplateNum1_9_0false() },
			],
			//  子组件选择投注数组完成后，结果传入父组件
			userSelectAry: [],
			// 传入投注卡子组件数据
			betAry: [],
			infoList: {}, //接受子组件的值
			zhList: [], //追号详情信息
			timer: null, //设置定时器
			selectTwoNav: 0, //当前选中的二级导航栏
			exampleObj: sscJson,
			bonus: 0, //奖金调节,
			lowLottery: [27, 28, 29],
			playGameName: "",
		};
	},
	methods: {
		//当前选中的二级导航栏
		selectTwoNavFun(e) {
			this.selectTwoNav = e.target.dataset.id;
		},
		getGameIcon() {
			this.navAry.forEach(item => {
				item.LotteryList.forEach(e => {
					if (e.LgId === this.GameIds) {
						this.logoImgUrl = "";
						this.logoImgUrl = `${this.imgUrl}/${e.WebIco}`;
					}
				});
			});
		},
		//显示追号弹框
		setTrack() {
			let that = this;
			if (that.betAry.length < 1) {
				that.betMinAShow();
			} else {
				if (that.betAry.length > 1) {
					that.openMessAge("追号投注,订单列表不能大于1项");
				} else {
					that.trackState = true;
				}
			}
		},
		// 关闭追号弹框
		hideTrack() {
			this.trackState = false;
		},
		// 追号投注后清除数组
		clearBetAry() {
			this.betAry = [];
		},
		// 接受投注位数的值
		getDisData(data) {
			this.betDis = data;
		},
		//计算投注数量
		setBetNum(data, value) {
			let that = this;
			this.BetNum = 0;
			if (value == undefined || value == null || value == "") {
			} else {
				this.betDis = value;
			}
			this.BetNum = data;
			this.CalcMount(data);
		},
		// 接受子组件的值
		infoData(data, num) {
			let that = this;
			let index = num; //1为普通订单，2位追号订单
			let obj = data;
			let ptid = data.OrderNumber; //普通订单号
			let zhid = data.ZhNumber; //追号订单号
			//获取普通投注数据
			if (index === 1) {
				let url = "Api/Order/GetDetailByOrderNumber?" + "number=" + ptid + "&type=" + index;
				that._initOpenLoading(false);
				postAjax(url)
					.then(function (data) {
						that._initCloseLoading();
						if (data.IsSucess) {
							that.infoList = data.Data[0];
						} else {
							that.openMessAge("获取详情失败，请重试");
							return false;
						}
					})
					.then(function () {
						that.$refs.dragDetali.dialogTableVisible = true;
					})
					.catch(() => {
						that._initCloseLoading();
						that.openMessAge("连接服务器失败,请重试");
					});
			}
			//追号记录 详情
			else if (index === 2) {
				let url = "Api/Order/GetDetailByOrderNumber?" + "number=" + zhid + "&type=" + index;
				that._initOpenLoading(false);
				postAjax(url)
					.then(function (data) {
						that._initCloseLoading();
						if (data.IsSucess) {
							that.zhList = data.Data;
							let allmoney = 0; //总金额
							let ykmoney = 0; //盈亏金额
							//计算总金额
							data.Data.forEach(item => {
								allmoney += item.BetMoney;
								ykmoney += item.WinBonus - item.BetMoney;
							});
							//添加到第一个数组
							data.Data[0]["allMoney"] = allmoney;
							data.Data[0]["ykMoney"] = ykmoney;
						} else {
							that.openMessAge("获取详情失败，请重试");
							return false;
						}
					})
					.then(function () {
						that.$refs.dragZhDetali.dialogVisible = true;
					})
					.catch(() => {
						that._initCloseLoading();
						that.openMessAge("连接服务器失败,请重试");
					});
			}
		},
		// 输入返回数组
		OptionGdata(data) {
			let that = this;
			this.selectGName = data;
			let len = that.betDis.length;
			let selectGNameLength = Number(this.selectGName.length);
			if ([62].includes(that.navsw)) {
				if (len === 4) {
					that.BetNum = selectGNameLength;
				} else if (len === 5) {
					that.BetNum = selectGNameLength * 5;
				} else {
					that.BetNum = 0;
				}
			} else if ([64, 67].includes(that.navsw)) {
				if (len === 3) {
					that.BetNum = selectGNameLength;
				} else if (len === 4) {
					that.BetNum = selectGNameLength * 4;
				} else if (len === 5) {
					that.BetNum = selectGNameLength * 10;
				} else {
					that.BetNum = 0;
				}
			} else if ([69].includes(that.navsw)) {
				if (len === 2) {
					that.BetNum = selectGNameLength;
				} else if (len === 3) {
					that.BetNum = selectGNameLength * 3;
				} else if (len === 4) {
					that.BetNum = selectGNameLength * 6;
				} else if (len === 5) {
					that.BetNum = selectGNameLength * 10;
				} else {
					that.BetNum = 0;
				}
			} else {
				this.BetNum = data.length;
			}
			this.CalcMount();
		},
		// 投注后返回的数据
		setGdata(data) {
			this.selectGName = data;
		},
		// 设置获取赔率数据
		setDorOdds() {
			let that = this;
			let ids = that.navsw;
			let list = that.navList;
			list.forEach(item => {
				if (ids === item.LpId) {
					that.gameOdds = item.JjList[that.CurrentPoint].Jj;
					that.gamePoint = item.JjList[that.CurrentPoint].Rebate;
				}
			});
			that.DorSomeAry.forEach(item => {
				if (item.name === "龙" || item.name === "虎") {
					item.odds = parseFloat(that.gameOdds / 4.5).toFixed(3);
				} else {
					item.odds = parseFloat(that.gameOdds).toFixed(1);
				}
			});
		},
		// 选择游戏倍率
		selectGameMultiply(data) {
			this.gameMultiplying = data;
			this.CalcMount();
		},
		//设置玩法赔率数组
		setUserSelect() {
			let that = this;
			let ids = that.navsw;
			that.navList.forEach(item => {
				if (ids === item.LpId) {
					let ary = item.JjList;
					let setAry = [];
					for (let i = 0; i < ary.length; i++) {
						let str = [ary[i].Jj.toFixed(3), ary[i].Rebate.toFixed(2)].join("-");
						setAry.push(str);
					}
					that.userSelect = setAry;
				}
			});
		},
		//计算投注金额
		CalcMount(data) {
			let that = this;
			if (data == undefined || data === "") {
				//当前投注数量
			} else {
				that.BetNum = data;
			}
			let type = that.mountType; //模式
			let name = that.mountTypeName;
			let num = that.gameMultiplying;

			type.forEach(item => {
				if (item.Name === name) {
					that.BetMoney = parseInt(that.BetNum) * parseInt(num) * parseFloat(item.Rate);
				}
			});
		},
		// 设置玩法模式
		TypeSet(data) {
			let that = this;
			that.mountTypeName = data;
			that.mountType.forEach(item => {
				if (item.Name === that.mountTypeName) {
					that.mountTypeId = item.Id;
					that.mountNum = item.Rate;
				}
			});
			that.CalcMount();
		},
		// num用方法生成 数字对象
		TemplateNum1_9_0false() {
			return [
				{ value: "1", state: false },
				{ value: "2", state: false },
				{ value: "3", state: false },
				{ value: "4", state: false },
				{ value: "5", state: false },
				{ value: "6", state: false },
				{ value: "7", state: false },
				{ value: "8", state: false },
				{ value: "9", state: false },
				{ value: "0", state: false },
			];
		},
		TemplateNum0_9false() {
			return [
				{ value: "0", state: false },
				{ value: "1", state: false },
				{ value: "2", state: false },
				{ value: "3", state: false },
				{ value: "4", state: false },
				{ value: "5", state: false },
				{ value: "6", state: false },
				{ value: "7", state: false },
				{ value: "8", state: false },
				{ value: "9", state: false },
			];
		},
		TemplateNum01_11false() {
			return [
				{ value: "01", state: false },
				{ value: "02", state: false },
				{ value: "03", state: false },
				{ value: "04", state: false },
				{ value: "05", state: false },
				{ value: "06", state: false },
				{ value: "07", state: false },
				{ value: "08", state: false },
				{ value: "09", state: false },
				{ value: "10", state: false },
				{ value: "11", state: false },
			];
		},
		//设置选号玩法数组
		setGameAry() {
			let that = this;
			that.gameAry = [];
			// 五星直选
			if ([1, 52, 61, 63, 68].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "万位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "千位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "百位", num: this.TemplateNum0_9false() },
					{ ids: 4, digit: "十位", num: this.TemplateNum0_9false() },
					{ ids: 5, digit: "个位", num: this.TemplateNum0_9false() },
				];
			}
			//五星组选120
			else if ([3].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组选120", num: this.TemplateNum0_9false() }];
			}
			//五星组选60 30
			else if ([4, 16, 5, 22].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "二重号", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "单号", num: this.TemplateNum0_9false() },
				];
			}
			//五星组选20
			else if ([6, 18, 24].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "三重号", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "单号", num: this.TemplateNum0_9false() },
				];
			}
			//五星组选10
			else if ([7].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "三重号", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "二重号", num: this.TemplateNum0_9false() },
				];
			}
			//五星组选5
			else if ([8].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "四重号", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "单号", num: this.TemplateNum0_9false() },
				];
			}
			//趣味玩法
			else if ([9].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "一帆风顺", num: this.TemplateNum0_9false() }];
			} else if ([10].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "好事成双", num: this.TemplateNum0_9false() }];
			} else if ([11].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "三星报喜", num: this.TemplateNum0_9false() }];
			} else if ([12].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "四季发财", num: this.TemplateNum0_9false() }];
			}
			// 四星前四直选
			else if ([13].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "万位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "千位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "百位", num: this.TemplateNum0_9false() },
					{ ids: 4, digit: "十位", num: this.TemplateNum0_9false() },
				];
			}
			// 四星组选24
			else if ([15, 21].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组选24", num: this.TemplateNum0_9false() }];
			}
			// 四星组选6
			else if ([17, 23].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组选6", num: this.TemplateNum0_9false() }];
			}
			// 四星后四直选
			else if ([19].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "千位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "百位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "十位", num: this.TemplateNum0_9false() },
					{ ids: 4, digit: "个位", num: this.TemplateNum0_9false() },
				];
			}
			// 前三直选
			else if ([25].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "万位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "千位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "百位", num: this.TemplateNum0_9false() },
				];
			}
			// 直选和值
			else if ([27].includes(that.navsw)) {
			}
			// 直选跨度
			else if ([28, 35, 42].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "跨度", num: this.TemplateNum0_9false() }];
			}
			// 前三组三复式
			else if ([29, 36, 43, 65, 171].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组三", num: this.TemplateNum0_9false() }];
			}
			// 前三组六复式
			else if ([30, 37, 44, 66, 172].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组六", num: this.TemplateNum0_9false() }];
			}
			// 中三直选
			else if ([32].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "千位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "百位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "十位", num: this.TemplateNum0_9false() },
				];
			}
			//后三直选
			else if ([39, 168, 180].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "百位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "十位", num: this.TemplateNum0_9false() },
					{ ids: 3, digit: "个位", num: this.TemplateNum0_9false() },
				];
			}
			//二星前二
			else if ([46, 174].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "万位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "千位", num: this.TemplateNum0_9false() },
				];
			}
			// 二星组选
			else if ([48, 51].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组选", num: this.TemplateNum0_9false() }];
			}
			// 二星后二
			else if ([49, 177].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "十位", num: this.TemplateNum0_9false() },
					{ ids: 2, digit: "个位", num: this.TemplateNum0_9false() },
				];
			}
			// 不定位
			else if ([53, 54, 55, 56, 57, 58, 59, 60, 181].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "不定位", num: this.TemplateNum0_9false() }];
			}
			// 11选5
			//三码直选复式
			else if ([94, 103].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "第一位", num: this.TemplateNum01_11false() },
					{ ids: 2, digit: "第二位", num: this.TemplateNum01_11false() },
					{ ids: 3, digit: "第三位", num: this.TemplateNum01_11false() },
				];
			}
			// 三码组选
			else if ([96, 100].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组选", num: this.TemplateNum01_11false() }];
			}
			//二码直选
			else if ([98].includes(that.navsw)) {
				that.gameAry = [
					{ ids: 1, digit: "第一位", num: this.TemplateNum01_11false() },
					{ ids: 2, digit: "第二位", num: this.TemplateNum01_11false() },
				];
			}
			// 不定位胆
			else if ([102].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "不定位", num: this.TemplateNum01_11false() }];
			}
			// 任选复式
			else if ([104].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "一中一", num: this.TemplateNum01_11false() }];
			} else if ([106].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "二中二", num: this.TemplateNum01_11false() }];
			} else if ([107].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "三中三", num: this.TemplateNum01_11false() }];
			} else if ([109].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "四中四", num: this.TemplateNum01_11false() }];
			} else if ([111].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "五中五", num: this.TemplateNum01_11false() }];
			} else if ([113].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "六中五", num: this.TemplateNum01_11false() }];
			} else if ([115].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "七中五", num: this.TemplateNum01_11false() }];
			} else if ([117].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "八中五", num: this.TemplateNum01_11false() }];
			}
			// 福彩3D
			else if ([176, 179].includes(that.navsw)) {
				that.gameAry = [{ ids: 1, digit: "组二", num: this.TemplateNum0_9false() }];
			}
		},
		// 选择玩法返点
		Bonusadjust(data) {
			let that = this;
			if (!data) {
				that.CurrentPoint = 0;
			} else {
				that.CurrentPoint = data;
			}
			// 设置龙虎斗玩法
			this.setDorOdds();
		},
		// 切换显示期号数量
		choice_data() {
			this.choicenum = true;
		},
		choice_data_other() {
			this.choicenum = false;
		},
		//导航栏点击切换
		topNavSwitch(e) {
			let that = this;
			that.selectTwoNav = 0; //重置默认选中二级菜单
			that.NavSwich = Number(e.target.dataset.id);
			this.hisStyle(e.target.dataset.id);
			that.setGameNav();
			// 清空子组件的值
			this.clearDrag();
			try {
				this.$refs.drag.selectAry = [];
				this.$refs.drag.val = "";
			} catch (e) {}
		},
		//历史记录样式调整
		hisStyle(num) {
			//0五星1四星2前三3中三4后三5二星0定位胆0不定位0任四任三任二
			//11前四12前二13后二14前四15后四
			let id = Number(this.$route.query.id);
			let that = this;
			if (id === 2 || id === 44) {
				let map = { 0: 2, 1: 3, 2: 4, 3: 8, 6: 0, 12: 8, 13: 5 };
				that.styleNum = map[Number(num)] || 0;
			} else {
				let map = { 0: 0, 1: 7, 2: 2, 3: 3, 4: 4, 5: 8, 8: 0, 12: 8, 13: 5, 14: 7, 15: 1 };
				that.styleNum = map[Number(num)] || 0;
			}
		},
		// 次级导航栏点击切换
		smallSwitch(e) {
			this.navsw = parseInt(e.target.dataset.id);
			this.gameName = e.target.dataset.name;
			// 初始化内容
			this.clearDrag();
			try {
				this.$refs.drag.selectAry = [];
				this.$refs.drag.val = "";
			} catch (e) {}
		},
		// 请求玩法数据
		gameAjax() {
			let that = this;
			let getPlayList = JSON.parse(window.sessionStorage.getItem("0playList" + that.GameIds));
			if (getPlayList) {
				that.navAllList = getPlayList;
				that.setGameNav();
				return false;
			}
			let url = "Api/Lp/GetPlayList?lpId=" + that.GameIds + "&pattern=0";
			this._initOpenLoading(false);
			getAjax(url)
				.then(function (data) {
					if (data.IsSucess) {
						that.navAllList = data.Data;
						window.sessionStorage.setItem("0playList" + that.GameIds, JSON.stringify(data.Data));
						that.loading.close();
					} else {
						that.openMessAge("加载玩法基础数据失败，请刷新页面");
					}
				})
				.then(function () {
					that.setGameNav();
				})
				.catch(() => {
					this.loading.close();
					this.openMessAge("加载玩法基础数据失败，请刷新页面");
				});
		},
		// 设置玩法导航
		setGameNav() {
			let that = this;
			that.navList = that.navAllList;
			if (that.GameIndex === "1") {
				if (that.GameIds === 2 || that.GameIds === 44) {
					if (that.NavSwich === 0) {
						that.navList = that.navList.slice(24, 31);
					} else if (that.NavSwich === 1) {
						that.navList = that.navList.slice(31, 38);
					} else if (that.NavSwich === 2) {
						that.navList = that.navList.slice(38, 45);
					} else if (that.NavSwich === 3) {
						that.navList = that.navList.slice(45, 51);
					} else if (that.NavSwich === 4) {
						that.navList = that.navList.slice(51, 52);
					} else if (that.NavSwich === 5) {
						that.navList = that.navList.slice(52, 60);
					} else if (that.NavSwich === 6) {
						that.navList = that.navList.slice(69);
					}
				} else {
					if (that.NavSwich === 0) {
						that.navList = that.navList.slice(0, 12);
					} else if (that.NavSwich === 1) {
						that.navList = that.navList.slice(12, 24);
					} else if (that.NavSwich === 2) {
						that.navList = that.navList.slice(24, 31);
					} else if (that.NavSwich === 3) {
						that.navList = that.navList.slice(31, 38);
					} else if (that.NavSwich === 4) {
						that.navList = that.navList.slice(38, 45);
					} else if (that.NavSwich === 5) {
						that.navList = that.navList.slice(45, 51);
					} else if (that.NavSwich === 6) {
						that.navList = that.navList.slice(51, 52);
					} else if (that.NavSwich === 7) {
						that.navList = that.navList.slice(52, 60);
					} else if (that.NavSwich === 8) {
						that.navList = that.navList.slice(69);
					} else if (that.NavSwich === 9) {
						that.navList = that.navList.slice(60, 62);
					} else if (that.NavSwich === 10) {
						that.navList = that.navList.slice(62, 67);
					} else if (that.NavSwich === 11) {
						that.navList = that.navList.slice(67, 69);
					}
				}
			}
			// 山东11选五
			if (that.GameIndex === "3") {
				if (that.NavSwich === 0) {
					that.navList = that.navList.slice(0, 4);
				} else if (that.NavSwich === 1) {
					that.navList = that.navList.slice(4, 8);
				} else if (that.NavSwich === 2) {
					that.navList = that.navList.slice(8, 9);
				} else if (that.NavSwich === 3) {
					that.navList = that.navList.slice(9, 10);
				} else if (that.NavSwich === 4 || that.NavSwich === 5) {
					let ary = that.navList.slice(10);
					let newAry = [];
					ary.forEach(item => {
						if (that.NavSwich === 4) {
							if (item.Name.indexOf("复式") !== -1) {
								newAry.push(item);
							}
						}
						if (that.NavSwich === 5) {
							if (item.Name.indexOf("单式") !== -1) {
								newAry.push(item);
							}
						}
					});
					that.navList = newAry;
				}
			}
			// 基诺彩
			else if (that.GameIndex === "6") {
				if (that.NavSwich === 0) {
					// 截取数组
					that.navList = that.navList.slice(0, 6);
				} else if (that.NavSwich === 1) {
					that.navList = that.navList.slice(6, 12);
				} else if (that.NavSwich === 2) {
					that.navList = that.navList.slice(12, 13);
				} else if (that.NavSwich === 3) {
					that.navList = that.navList.slice(13);
				}
			}
			// 设置次级导航栏状态
			that.navsw = that.navList[0].LpId;
			//获取玩法名称
			that.gameName = that.navList[0].Name;
			//获取模式数组
			that.navList.forEach(item => {
				if (that.navsw === item.LpId) {
					that.mountType = item.AmList;
				}
			});
			// 设置玩法数组
			that.setGameAry();
			// 获取赔率
			that.setDorOdds();
			// 设置玩法倍率
			that.setUserSelect();
		},
		upTimeData() {
			if (this.NowLssue) {
				this.$notify({
					title: "温馨提示",
					type: "warning",
					showClose: false,
					message: this.NowLssue + " 已停止销售,请注意当前期号",
					position: "bottom-right",
				});
			}
			this.timeAjax();
		},
		//请求投注期号
		timeAjax() {
			let that = this;
			that.countDown = {
				state: false,
			};
			let url = "Api/Lssue/GetBetLssueInfo";
			let data = {
				lgId: that.GameIds,
			};
			let openState = true; //是否需要请求开奖
			getAjax(url, data)
				// 请求成功后赋值
				.then(function (data) {
					window.NowLssue = data.Data.NowLssueFormat;
					that.NowLssue = data.Data.NowLssueFormat;
					that.LastLssue = data.Data.LastLssueFormat;
					that.dirNowLssue = data.Data.NowLssue;
					that.openTime = data.Data.LastLssue; //开奖期号
					that.countDown = {
						time: data.Data.NowLssueRemainTime,
						state: true,
					};
					that.NowTime = SecondToHHSSMM(data.Data.NowLssueRemainTime);
					if (data.Data.LastOpenNumber == null || data.Data.LastOpenNumber === "") {
						that.LastNum = { state: false, arr: ["?", "?", "?", "?", "?"] };
						openState = true; //无开奖号码
						that.animationState = false;
					} else {
						that.LastNum = { state: true, arr: data.Data.LastOpenNumber.split(",") };
						openState = false; //有开奖号码
					}
				})
				.then(function () {
					// 如果没有开奖号，开始执行倒计时请求开奖号码
					if (openState) {
						that.setTimer();
					}
				})
				.catch(() => {
					that.openMessAge("加载期号失败，请刷新页面");
				});
		},
		// 设置倒计时请求开奖号码
		setTimer() {
			let that = this;
			if (this.timer == null) {
				this.timer = setInterval(() => {
					that.getResultNum();
				}, 5000);
			}
		},
		// 获取近5期投注期号
		PhaseAjax() {
			let that = this;
			let url = "Api/Lssue/GetLssueHistoryInfo";
			let data = {
				lgId: that.GameIds,
			};
			getAjax(url, data).then(function (data) {
				if (data.IsSucess) {
					if (data.Data != null) {
						that.playGameName = data.Data[0].lgText;
						that.allLotterydata = [...data.Data];
					}
				}
			});
		},
		//计算投注金额
		CompentMount() {
			let that = this;
			that.NumBet = that.betAry.length;
			let num = 0;
			that.betAry.forEach(item => {
				if (!item.mount) {
					item.mount = 0;
				}
				num += parseInt(item.mount);
			});
			that.MoneyBets = parseInt(num);
		},
		// 初始化内容
		clearDrag() {
			let that = this;
			try {
				that.GameState = false;
				that.GameState = true;
				this.gameMultiplying = 1;
				// 获取赔率
				this.setDorOdds();
				// 设置玩法下拉内容
				this.setUserSelect();
				// 初始化游戏数组
				this.stateAry();
				this.setGameAry();

				this.selectGName = "";
				// 初始化投注金额
				this.BetNum = 0;
				this.BetMoney = 0;
				this.betDis = [];
				this.$refs.drag.selectAry = [];
				this.$refs.drag.val = "";
			} catch (e) {}
		},
		// 清空投注卡列表
		EmptyNum(Data) {
			let that = this;
			that.betAry = Data;
			// 计算投注金额
			that.CompentMount();
		},
		// 删除投注卡某一列
		deleteNum(Data) {
			let that = this;
			that.betAry.splice(Data, 1);
			// 计算投注金额
			that.CompentMount();
		},
		// 显示提示框
		openMessAge(data) {
			this.$message.error(data);
		},
		// 显示弹框 隐藏弹框
		betMinAShow() {
			this.betMinA = true;
		},
		betMinAHide() {
			this.betMinA = false;
		},
		// 显示投注成功框
		showBetSuc() {
			this.betSuccess = true;
			this.autoHideBetSuc = setTimeout(this.hideBetSuc, 2000);
		},
		hideBetSuc() {
			this.betSuccess = false;
			this.autoHideBetSuc = null;
		},
		//初始化话传入数组状态
		stateAry() {
			this.DorSomeAry.forEach(item => {
				item.state = "false";
			});
			this.gameAry.forEach(item => {
				item.num.forEach(e => {
					e.state = false;
				});
			});
		},
		_initOpenLoading(isFlag = true) {
			this.loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
		},
		_initCloseLoading() {
			this.loading.close();
		},
		// 投注数据
		// 扩展一个字段，isFlag为true显示投注中,false为默认加载中
		ListAjax() {
			let that = this;
			let url = "api/OrderReport/BetHistory" + "?lgid=" + that.GameIds;
			postAjax(url).then(function (data) {
				if (data.IsSucess) {
					that.tableList = data.Data;
				}
			});
			// 追号数据
			let url2 = "api/OrderReport/ZHHistory?lgid=" + that.GameIds;
			postAjax(url2).then(function (data) {
				if (data.IsSucess) {
					that.trackList = data.Data;
				}
			});
		},
		//设置传入投注卡的数组
		addNum() {
			let that = this;
			let obj = {};
			obj["name"] = that.gameName; //名称
			obj["GAry"] = that.selectGName; //投注内容
			obj["num"] = that.BetNum; //注数
			obj["mount"] = that.BetMoney; //投注金额
			obj["type"] = that.mountTypeName; //投注模式
			obj["Odds"] = that.gameOdds + "-" + that.gamePoint; //奖金返点
			obj["GMult"] = that.gameMultiplying; //倍率
			obj["ids"] = that.navsw; //玩法id
			obj["Gids"] = that.GameIds; //玩法种类
			obj["data"] = that.dirNowLssue; //当前期号
			obj["gameOdd"] = that.gameOdds; //投注奖金
			obj["reba"] = that.gamePoint; //返点
			obj["RxD"] = that.betDis.length > 0 ? that.betDis.join("") : null; //位数
			obj["bon"] = that.mountTypeId; //投注模式ID
			if (that.BetNum < 1) {
				that.betMinAShow();
			} else {
				if ([62].includes(that.navsw)) {
					if (that.betDis.length < 4) {
						that.openMessAge("位数最少选择4个");
						return false;
					}
				}
				if ([64, 67, 65, 66].includes(that.navsw)) {
					if (that.betDis.length < 3) {
						that.openMessAge("位数最少选择3个");
						return false;
					}
				}
				if ([69].includes(that.navsw)) {
					if (that.betDis.length < 2) {
						that.openMessAge("位数最少选择2个");
						return false;
					}
				}
				that.betAry.push(obj);
				//添加成功后初始化数据
				that.clearDrag();
				that.selectGName = [];
				try {
					this.$refs.drag.selectAry = [];
					this.$refs.drag.val = "";
				} catch (e) {}
			}
		},
		// 数组投注
		aryDisAjax() {
			let that = this;
			let zxState = true;
			if (that.betAry.length < 1) {
				that.betMinAShow();
			} else {
				let url = "Api/Bet/AddClassicPatternOrder?" + "lssue=" + that.dirNowLssue + "&LgId=" + that.GameIds;
				let order = [];
				let ListAllMoney = 0;
				that.betAry.forEach(item => {
					// 传入后端格式
					if ([62, 178, 175, 173, 169, 50, 47, 2, 14, 20, 26, 31, 33, 38, 40, 45].includes(item.ids)) {
						zxState = false;
					}
					let obj = {};
					obj["BetMoney"] = item.mount;
					obj["BetMultiple"] = item.GMult;
					obj["LpId"] = item.ids;
					obj["PlayName"] = item.name;
					obj["BetContent"] = zxState ? item.GAry.join(",") : item.GAry.join(" ");
					obj["BetCount"] = item.num;
					obj["BetRebate"] = item.reba;
					obj["BetBonus"] = item.gameOdd;
					obj["BonusMode"] = item.bon;
					obj["RxDsFormart"] = item.RxD;
					order.push(obj);
					ListAllMoney += item.BetMoney;
				});
				// 已选择了号码，则进行loadong提示
				this.loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
				postAjax(url, order, 1)
					.then(data => {
						this.loading.close();
						if (data.IsSucess === true) {
							if (data.Data.ErrorInfos.length > 0) {
								that.openMessAge(
									"成功投注：" + data.Data.SuccessCount + "注，投注失敗：" + data.Data.ErrorInfos.length + "注"
								);
							} else {
								that.showBetSuc();
							}
							that.getUserInfo();
							// 刷新表单数据
							that.ListAjax();
						} else if (data.IsSucess === false) {
							that.openMessAge(data.Message);
						}
					})
					.then(function () {
						that.betAry = [];
						that.loading.close();
						// 初始化子组件状态
						that.clearDrag();
					})
					.catch(() => {
						that.loading.close();
						that.openMessAge("连接服务器失败,请重试");
					});
			}
		},
		//直接投注
		DisAjax() {
			let that = this;
			let url = "Api/Bet/AddClassicPatternOrder?" + "lssue=" + that.dirNowLssue + "&LgId=" + that.GameIds;
			let zxState = true;
			if (that.BetNum < 1) {
				that.betMinAShow();
			} else if (that.BetMoney > that.userBalace) {
				that.openMessAge("您的可用余额不足，请重新选择");
				return false;
			} else {
				if ([67, 64, 62, 175, 178, 173, 169, 50, 47, 2, 14, 20, 26, 31, 33, 38, 40, 45].includes(that.navsw)) {
					zxState = false;
				}
				if ([62].includes(that.navsw)) {
					if (that.betDis.length < 4) {
						that.openMessAge("位数最少选择4个");
						return false;
					}
				}
				if ([64, 67, 65, 66].includes(that.navsw)) {
					if (that.betDis.length < 3) {
						that.openMessAge("位数最少选择3个");
						return false;
					}
				}
				if ([69].includes(that.navsw)) {
					if (that.betDis.length < 2) {
						that.openMessAge("位数最少选择2个");
						return false;
					}
				}
				let order = [
					{
						BetMoney: that.BetMoney,
						BetMultiple: that.gameMultiplying,
						LpId: that.navsw,
						PlayName: that.gameName,
						BetContent: zxState ? that.selectGName.join(",") : that.selectGName.join(" "),
						BetCount: that.BetNum,
						BetRebate: that.gamePoint,
						BetBonus: that.gameOdds,
						BonusMode: that.mountTypeId,
						RxDsFormart: that.betDis.length > 0 ? that.betDis.join("") : null,
					},
				];
				this._initOpenLoading();
				postAjax(url, order, 1)
					.then(data => {
						that._initCloseLoading();
						if (data.IsSucess === true) {
							that.showBetSuc();
							that.getUserInfo();
							// 刷新表单数据
							that.ListAjax();
						} else if (data.IsSucess === false) {
							that.openMessAge(data.Message);
						}
					})
					.then(() => {
						that._initCloseLoading();
						//  初始化数组状态
						that.stateAry();
						// 初始化子组件状态
						that.clearDrag();
					})
					.catch(() => {
						that.openMessAge("连接服务器失败,请重试");
						this._initCloseLoading();
					});
			}
		},
		// 一键梭哈
		AllIN() {
			let that = this;
			let userMoney = parseFloat(that.userBalace); //用户余额
			let betnum = parseInt(that.BetNum); //投注数量
			let money = that.mountNum; //基数金钱

			if (that.BetNum < 1) {
				that.betMinAShow();
			} else if (userMoney < betnum * money) {
				that.openMessAge("您的余额不足，请充值");
			} else {
				// 当前梭哈倍数
				let num = Math.floor(userMoney / parseFloat(betnum * money)); //获取倍数
				let intMoney = parseFloat(num * money * betnum); //获取金额
				that.gameMultiplying = num;
				that.BetMoney = intMoney;
			}
		},
		// 请求游戏图片
		getGImg() {
			let that = this;
			let url = "Api/Lnc/Get";
			getAjax(url)
				.then(function (data) {
					data.Data.forEach(item => {
						item.LotteryList.forEach(e => {
							if (e.LgId == that.GameIds) {
								that.imgUrl = that.imgUrl + e.WebIco;
							}
						});
					});
				})
				.catch(() => {
					//  that.openMessAge("网络出现异常，请刷新后重试")
				});
		},
		//请求用户数据
		getUserInfo() {
			let that = this;
			let url = "Api/User/GetUserInfo";
			postAjax(url)
				.then(function (data) {
					// 提交用户信息到vuex
					that.userBalace = data.Data.Balance;
					// 提交用户信息到vuex
					that.$store.commit("setUserInfo", data.Data);
				})
				.catch(() => {});
		},
		// 获取开奖号码
		getResultNum() {
			let that = this;
			let url = "Api/Lssue/GetLssueOpenInfo?lgId=" + that.GameIds + "&lssue=" + that.openTime;
			getAjax(url)
				.then(function (data) {
					window.lgText = data.Data.lgText;
					if (data.Data.OpenNumber == null || data.Data.OpenNumber === "") {
					} else {
						// 显示弹框
						that.openGifClass = "icon";
						that.LastNum = { state: true, arr: data.Data.OpenNumber.split(",") };
						that.openDataRe["LastOpenNumber"] = data.Data.OpenNumber.split(",");
						that.openDataRe["Time"] = that.LastLssue;
						that.openDataRe["Name"] = data.Data.lgText;
						that.openFrame = true;
						// 清除倒计时
						clearInterval(that.timer);
						that.timer = null;
						// 请求近5期期号数据
						that.PhaseAjax();
						// 请求表单数据
						that.ListAjax();
						// 请求用户数据
						that.getUserInfo();
					}
				})
				.catch(() => {
					// that.openMessAge("网络请求出现错误，请刷新页面后重试")
				});
		},
		// 关闭开奖弹框
		hideOpenRe() {
			this.openFrame = false;
			this.timeNum = 0;
		},
		handleWinFocus() {
			this.timeAjax();
		},
		//奖金调节
		adjustMent() {
			this.Bonusadjust(this.bonus);
		},
	},
	components: {
		openResult,
		zhDetali,
		trackNum,
		betting,
		tablelist,
		userpay,
		gameCom,
		optionvalue,
		dragon,
		flextab,
		betElast,
		betSuccess,
		detali,
		gameCount,
		history,
		openNumber,
		favorite,
		favoriteList,
		countDown,
		gamePanelTitle,
	},
	computed: {
		navAry() {
			return this.$store.state.navAry; //导航栏数据
		},
		lowLotteryClass() {
			return this.lowLottery.includes(this.GameIds);
		},
	},
	// 监听刷新页面
	watch: {
		$route() {
			this.reload();
		},
		navAry(val) {
			this.getGameIcon();
		},
	},
	beforeCreate() {
		clearInterval(this.timer);
		this.timer = null;
	},
	destroyed() {
		// 每次离开当前界面时，清除定时器
		clearInterval(this.timer);
	},
	created() {
		// 请求数据
		this.gameAjax();
		// 请求期号数据
		this.timeAjax();
		// 请求数据
		this.ListAjax();
		// 请求用户数据
		this.getUserInfo();
		// 请求近5期期号数据
		this.PhaseAjax();
		// 请求游戏图片
		this.getGameIcon();
	},
	beforeDestroy() {
		clearInterval(this.timer);
		window.removeEventListener("focus", this.handleWinFocus);
	},
	mounted() {
		window.addEventListener("focus", this.handleWinFocus);
	},
};
</script>

<style lang="scss" scoped>
/* 主要内容开始 */
.Timhonor_content_box {
	position: relative;
	width: 100%;
}

.game_message_box {
	.el-button {
		display: none;
	}
}

$max: 6;

@for $i from 1 through $max {
	.h-#{$i} {
		font-size: ($max - $i + 1) * 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Timehonored.vue